<template>
  <div class="list-section">
    <div class="search-bg">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-row :gutter="22">
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text111') + '：'"
              class="search-label"
            >
              <el-input
                v-model="searchForm.fundAccountId"
                placeholder=""
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text88') + '：'"
              class="search-label"
            >
              <el-input
                v-model="searchForm.name"
                placeholder=""
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text216') + '：'"
              class="search-label"
            >
              <el-input
                v-model="searchForm.mt4LoginId"
                placeholder=""
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text138') + '：'"
              class="search-label"
            >
              <el-input
                v-model="searchForm.ruleGroupName"
                placeholder=""
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text257') + '：'"
              class="search-label"
            >
              <el-select clearable v-model="searchForm.SProxyId" placeholder="">
                <el-option
                  v-for="agent in formattedAgents"
                  :key="agent.proxyId"
                  :label="agent.indentedName"
                  :value="agent.proxyId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22" style="margin-top: 10px">
          <el-col :span="4" v-if="agentConfig.phoneLoginReg">
            <el-form-item
              :label="$t('proxy.text89') + '：'"
              class="search-label"
            >
              <el-input
                v-model="searchForm.Phone"
                placeholder=""
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="agentConfig.emailLoginReg">
            <el-form-item
              :label="$t('proxy.text34') + '：'"
              class="search-label"
            >
              <el-input
                v-model="searchForm.Email"
                placeholder=""
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item>
              <el-button
                type="primary"
                @click="fetchData"
                class="search-button"
                >{{ $t("proxy.text13") }}</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <el-table :data="allData" style="width: 100%">
        <el-table-column
          min-width="120px"
          prop="userId"
          :label="$t('proxy.text84')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="150px"
          prop="fundAccountName"
          :label="$t('proxy.text88')"
          align="center"
        >
          <template #default="scope">
            <span>{{ scope.row.fundAccountName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="150px"
          prop="proxyName"
          :label="$t('proxy.text257')"
          align="center"
        ></el-table-column>
        <el-table-column
          v-if="agentConfig.phoneLoginReg"
          min-width="150px"
          prop="phone"
          :label="$t('proxy.text89')"
          align="center"
        >
          <template #default="scope">
            <span>{{ scope.row.phone || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="agentConfig.emailLoginReg"
          min-width="180px"
          prop="email"
          align="center"
          :label="$t('proxy.text34')"
        >
          <template #default="scope">
            <div class="break-word">
              {{ scope.row.email ? scope.row.email : "--" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="130px"
          prop="fundAccountId"
          :label="$t('proxy.text111')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="130px"
          prop="mt4LoginId"
          :label="$t('proxy.text216')"
          align="center"
        >
          <template #default="scope">
            <span>{{ scope.row.mt4LoginId || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="150px"
          prop="webAmount"
          :label="$t('proxy.text130')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="150px"
          prop="webNetAssets"
          :label="$t('proxy.text131')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="150px"
          prop="webUsedAmountRate"
          :label="$t('proxy.text132')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="150px"
          prop="mt4Amount"
          :label="$t('proxy.text274')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="150px"
          prop="mt4Equity"
          :label="$t('proxy.text275')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="150px"
          prop="mt4UsedAmountRate"
          :label="$t('proxy.text276')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="150px"
          prop="netInMargin"
          :label="$t('proxy.text136')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="150px"
          prop="netCommission"
          :label="$t('proxy.text137')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="150px"
          prop="rulesGroupName"
          :label="$t('proxy.text229')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="250px"
          :label="$t('proxy.text139')"
          align="center"
          fixed="right"
        >
          <template #default="scope">
            <div class="button-group">
              <el-button
                class="view-account"
                @click="handleViewAccount(scope.row)"
              >
                {{ $t("proxy.text140") }}
              </el-button>
              <el-button
                class="transaction-history"
                @click="handleViewHistory(scope.row)"
              >
                {{ $t("proxy.text86") }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handlePageChange"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        :page-size="pageSize"
        :total="totalEntries"
        :page-sizes="[10, 50, 100, 200]"
        :disabled="false"
        :background="true"
        layout="total, prev, pager, next, sizes"
        class="pagination-container"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import apiService from "@/api/request";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    const route = useRoute(); // 获取路由信息
    const router = useRouter(); // 路由实例
    const initialUserId = ref(route.query.userId || null); // 获取初始的用户ID
    const agentConfig = computed({ get: () => store.getters.getAgentConfig });

    const searchForm = ref({
      fundAccountId: "",
      name: "",
      userId: initialUserId.value,
      mt4LoginId: "",
      ruleGroupName: "",
      SProxyId: "",
      Phone: "",
      Email: "",
    });

    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalEntries = ref(0);
    const allData = ref([]);
    const formattedAgents = ref([]);

    const fetchAgents = async () => {
      try {
        const params = {
          containRoot: true,
        };
        const response = await apiService.proxyAllSubProxyList(params);
        formattedAgents.value = formatAgents(
          response.data.proxyTree ? response.data.proxyTree : []
        );
      } catch (error) {
        console.error("获取代理列表失败:", error);
      }
    };

    const formatAgents = (agentsList, level = 0) => {
      return agentsList.flatMap((agent) => {
        const indentedAgent = {
          proxyId: agent.proxyId,
          indentedName: `${" ㅤ".repeat(level)}${agent.proxyName}`,
        };
        const children = agent.childProxyInfo
          ? formatAgents(agent.childProxyInfo, level + 1)
          : [];
        return [indentedAgent, ...children];
      });
    };

    const fetchData = async () => {
      try {
        const params = {
          Page: currentPage.value,
          Limit: pageSize.value,
          fundAccountId: searchForm.value.fundAccountId,
          name: searchForm.value.name,
          mt4LoginId: searchForm.value.mt4LoginId,
          ruleGroupName: searchForm.value.ruleGroupName,
          SProxyId: searchForm.value.SProxyId, // 使用 SProxyId 进行筛选
          Phone: searchForm.value.Phone,
          Email: searchForm.value.Email,
          userId: searchForm.value.userId,
        };

        const response = await apiService.proxyFundAccountList(params);
        const { list, count } = response.data;
        allData.value = list;
        totalEntries.value = count;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const handlePageChange = (page) => {
      currentPage.value = page;
      fetchData();
    };

    const handleSizeChange = (size) => {
      pageSize.value = size;
      fetchData();
    };

    // 查看持仓跳转
    const handleViewAccount = (row) => {
      router.push({
        name: "agentPositionList",
        query: {
          FundAccountId: row.fundAccountId, // Web账号ID
          activeMenu: "positionlist",
        },
      });
    };

    // 查看交易历史跳转
    const handleViewHistory = (row) => {
      router.push({
        name: "agentTradeHistory",
        query: {
          FundAccountId: row.fundAccountId, // Web账号ID
          activeMenu: "tradehistory",
        },
      });
    };

    onMounted(() => {
      fetchAgents().then(() => {
        // 在代理列表加载完成后再请求数据
        fetchData();
      });
    });

    return {
      searchForm,
      currentPage,
      pageSize,
      totalEntries,
      allData,
      formattedAgents,
      fetchData,
      formatAgents,
      handlePageChange,
      handleSizeChange,
      handleViewAccount,
      handleViewHistory,
      agentConfig,
    };
  },
};
</script>


<style lang="less" scoped>
.view-account,
.transaction-history {
  font-size: 14px;
  border: none;
}

.button-group {
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  gap: 0px; /* 按钮之间的间距 */
}

.view-account,
.transaction-history {
  font-size: 14px;
  padding: 10px;
  margin: 0;
  color: inherit; /* 按钮文字继承颜色 */
}

.view-account {
  color: #51b4f1; /* 视图按钮颜色 */
}

.transaction-history {
  color: #67c23a; /* 交易记录按钮颜色 */
}
</style>
